import {
  IRubricDTO,
  IRubricFieldDTO,
  IRubricOptionDTO,
  IRubricSectionDTO,
  SubmissionRubricFormDTO,
} from '@/dtos';
import { get, post, remove } from '../apiWrapper';

export const createRubricForYearAPI = async (yearId: string): Promise<IRubricDTO> => {
  const ret = await post<IRubricDTO>(`/admin/year/${yearId}/Rubric/createe`);
  return ret;
};

export const updateRubricAPI = async (Rubric: IRubricDTO): Promise<IRubricDTO> => {
  const ret = await post<IRubricDTO>(`/admin/Rubric/${Rubric.id}'`, Rubric);
  return ret;
};

export const createRubricSectionAPI = async (
  section: IRubricSectionDTO,
): Promise<IRubricSectionDTO> => {
  const ret = await post<IRubricSectionDTO>(`/admin/Rubric/sections/create`, section);
  return ret;
};

export const updateRubricSectionsAPI = async (
  rubricId: string,
  sections: IRubricSectionDTO[],
): Promise<{ data: IRubricSectionDTO[]; count: number }> => {
  const ret = await post<{ data: IRubricSectionDTO[]; count: number }>(
    `/admin/rubric/${rubricId}/sections`,
    sections,
  );
  return ret;
};
export const deleteRubricSectionAPI = async (section: IRubricSectionDTO): Promise<boolean> => {
  const ret = await remove<boolean>(`/admin/rubric/section/${section.id}`);
  return ret;
};

export const createRubricFieldAPI = async (field: IRubricFieldDTO): Promise<IRubricFieldDTO> => {
  const ret = await post<IRubricFieldDTO>(`/admin/rubric/fields/create`, field);
  return ret;
};
export const deleteRubricFieldAPI = async (field: IRubricFieldDTO): Promise<boolean> => {
  const ret = await remove<boolean>(`/admin/rubric/field/${field.id}`);
  return ret;
};

export const updateRubricFieldsAPI = async (
  rubricId: string,
  sectionId: string,
  fields: IRubricFieldDTO[],
): Promise<{ data: IRubricFieldDTO[]; count: number }> => {
  const ret = await post<{ data: IRubricFieldDTO[]; count: number }>(
    `/admin/rubric/${rubricId}/section/${sectionId}/fields`,
    fields,
  );
  return ret;
};

export const createRubricOption = async (option: IRubricOptionDTO): Promise<IRubricOptionDTO> => {
  const ret = await post<IRubricOptionDTO>(`/admin/rubric/option/create`, option);
  return ret;
};

export const createSubmissionRubricFormAPI = async (
  submissionId: string,
): Promise<SubmissionRubricFormDTO> => {
  const submission = await post<SubmissionRubricFormDTO>(
    `/judge/submission/${submissionId}/rubric-form/create`,
  );
  return submission;
};
export const getSubmissionRubricFormAPI = async (
  submissionId: string,
): Promise<SubmissionRubricFormDTO> => {
  const submission = await get<SubmissionRubricFormDTO>(
    `/judge/submission/${submissionId}/rubric-form`,
  );
  return submission;
};

export const updateSubmissionRubricFormAPI = async (
  submissionId: string,
  submissionEntryForm: SubmissionRubricFormDTO,
): Promise<SubmissionRubricFormDTO> => {
  const submission = await post<SubmissionRubricFormDTO>(
    `/judge/submission/${submissionId}/rubric-form/update`,
    submissionEntryForm,
  );
  return submission;
};
